// Banner.js
import React from 'react';
import './Banner.css';

const Banner = () => {
  return (
    <div className="banner-section">
      <div className="banner-header">
        <h2>Advancing your product innovations</h2>
      </div>
      <div className="banner-text">
        <p>
        At Pharm-Rx, our expertise and industry insight enable us to source cutting-edge ingredients, helping you stay ahead of market trends and develop innovative products.
        </p>
      </div>
    </div>
  );
};

export default Banner;
